// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vueTap from 'v-tap'
import App from '@/views/app'
import store from '@/store/index'
import router from '@/router'
import '@/style/index.less'
import icon from '@/components/icon'
import { dateFormat } from '@/utils'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger.vue'

Vue.config.productionTip = false

const icons = require.context('@/assets/icons', true, /\.(svg|png)$/)
const importAll = (r) => {
  r.keys().forEach(key => {
    r(key)
  })
}
importAll(icons)
Vue.component('icon', icon)
Vue.use(vueTap)

Vue.filter('moment', dateFormat)

Vue.use(AlloyFingerPlugin, {
  AlloyFinger
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/entry/index.js